import { useState } from 'react'

import { QrCodeGenerator } from './QrCodeGenerator'
import { QrCodeContent, Styling } from '../hooks/useQrCode'
import { StylingForm } from './StylingForm'
import { useBranding } from '@/features/branding'
import { TypeForm } from './TypeForm'

export function QrCodeForm() {
  const { branding } = useBranding()

  const [contents, setContents] = useState<QrCodeContent[]>([])

  const [styling, setStyling] = useState<Styling>({
    color: branding.colors.primary,
    cornerDotType: 'classy',
    dotType: 'classy',
    cornerSquareType: 'classy',
    shape: 'square',
    withLogo: true,
    withText: true
  })

  return (
    <div className="flex flex-col bg-white rounded-small p-8 gap-10">
      <div className="flex flex-col gap-4">
        <StylingForm value={styling} onChange={setStyling} />
        <TypeForm onChange={setContents} />
      </div>
      {contents.length > 0 && (
        <QrCodeGenerator contents={contents} styling={styling} />
      )}
    </div>
  )
}
